import { ChangeOrderPaymentStatusPartiallyByMarkerRequest } from '@/Api/MpOrdersMarking/Requests';
import { DateFormatType, OrderMarker, OrderStatusFilterGroups } from '@/Enums';
import { useForm } from '@/Hooks/useFormWrapper';
import { useRequired } from '@/Hooks/Validation';
import { purchasesPageAsyncActions } from '@/Pages/Purchases/services';
import { salesPageActions } from '@/Pages/Sales/services';
import { dateTimeUtils } from '@/Utils/DateTimeUtils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { changePaymentAsyncActions } from '@/ModalWindows/ChangePaymentStatusModal/services/asyncActions';

type FormData = ChangeOrderPaymentStatusPartiallyByMarkerRequest;

export const usePaidAndNotPaidForm = (orderIds: number[], isSalesPage: boolean, onClose: () => void) => {
  const dispatch: AppDispatch = useDispatch();

  const methods = useForm<FormData>({
    defaultValues: {
      orderIds,
      orderMarker: OrderMarker.Paid,
      overwritePreviousDates: false,
      paymentDate: dateTimeUtils.getCurrentDateTime(DateFormatType.LOCAL_DATE_TIME),
    },
  });

  // variables
  const needShowDate = methods.watch('orderMarker') === OrderMarker.Paid;

  // rules
  const required = useRequired();
  const dateRequired = useRequired(needShowDate);

  // function
  const submit = useCallback(
    (data: FormData) => {
      dispatch(
        changePaymentAsyncActions.changeOrderPaymentStatusPartially({
          ...data,
          paymentDate: dateTimeUtils.localStringToUtcString(data?.paymentDate),
        }),
      ).then(() => {
        if (isSalesPage) {
          dispatch(
            salesPageActions.removeOrdersFromStateByCurrentFilters({
              orderIds: data.orderIds,
              filters: data.orderMarker === OrderMarker.NotPaid ? OrderStatusFilterGroups.NotPaidGroup : [],
            }),
          );
        } else {
          dispatch(purchasesPageAsyncActions.getPurchasesWithCurrentFilters());
        }

        onClose();
      });
    },
    [orderIds, onClose, isSalesPage],
  );

  return {
    methods,
    needShowDate,
    submit: methods.handleSubmit(submit),
    rules: {
      required,
      dateRequired,
    },
  };
};
